"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpPage = void 0;
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const gettext_1 = require("@integro/gettext");
const page_html_1 = __importDefault(require("./page.html"));
let ItpPage = class ItpPage extends vue_property_decorator_1.Vue {
    loading;
    reloading;
    loadingSpinner;
    loaded;
    error;
    modal;
    card;
    modalBindings;
    size;
    modalName;
    data() {
        return {
            componentName: this.modal ? 'ItpModal' : 'DIV',
            componentBindings: this.getComponentBindings(),
            componentEventListeners: this.getComponentEventListeners(),
            contentClassName: this.getContentClassName(),
            msgReload: (0, gettext_1.pgettext)('UserControlButton', 'Reload'),
            msgReloading: (0, gettext_1.pgettext)('UserControlMessage', 'Reloading...')
        };
    }
    getComponentBindings() {
        let result = this.modal ? this.modalBindings : {};
        if (this.size) {
            result = _.extend(result, { size: this.size });
        }
        return result;
    }
    getContentClassName() {
        return this.modal ? null : 'page--v2 d-flex flex-column';
    }
    getComponentEventListeners() {
        return this.modal ? { onClose: _.bind(this.onClose, this) } : {};
    }
    onClose(args) {
        this.$emit('close', args);
    }
    beforePageLeave() {
        console.log('RouterTab - beforePageLeave', this);
    }
    beforeRouteEnter(to, from, next) {
        console.log('ComponentMixins - beforeRouteEnter', this);
    }
    beforeRouteUpdate(to, from, next) {
        console.log('ComponentMixins - beforeRouteUpdate', this);
    }
    beforeRouteLeave(to, from, next) {
        console.log('ComponentMixins - beforeRouteLeave', this);
    }
};
exports.ItpPage = ItpPage;
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPage.prototype, "loading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPage.prototype, "reloading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPage.prototype, "loadingSpinner", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPage.prototype, "loaded", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Error)
], ItpPage.prototype, "error", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPage.prototype, "modal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPage.prototype, "card", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object }),
    __metadata("design:type", Object)
], ItpPage.prototype, "modalBindings", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String }),
    __metadata("design:type", String)
], ItpPage.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String }),
    __metadata("design:type", String)
], ItpPage.prototype, "modalName", void 0);
exports.ItpPage = ItpPage = __decorate([
    (0, vue_property_decorator_1.Component)({ template: page_html_1.default })
], ItpPage);
//# sourceMappingURL=page.js.map